<div class="example-container mat-card mat-elevation-z4 p-24">

  <form class="">
    <div class="h2 mb-24" *ngIf="tipoPregunta == 1">{{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.MULTI.TITULOSING' | translate}}</div>
    <div class="h2 mb-24" *ngIf="tipoPregunta == 2 ">{{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.MULTI.TITULOMULT' | translate}}</div>
    <div class="h2 mb-24" *ngIf="tipoPregunta == 7 ">{{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.MULTI.TITULOLIKERT3' | translate}}</div>
    <div class="h2 mb-24" *ngIf="tipoPregunta == 8 ">{{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.MULTI.TITULOLIKERT5' | translate}}</div>
    <div class="h2 mb-24" *ngIf="tipoPregunta == 9">multiple likert</div>

    <mat-form-field appearance="outline" style="width:100%">
      <mat-label>{{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.MULTI.ACCION' | translate}}</mat-label>
      <textarea matInput required
        (keyup)="enviaTextoPregunta($event)"
        (blur)="guardaPregunta()"
        [(ngModel)]="textoEntrada"
        [disabled]="pasoCompleto"
        name="textoOpciones"
      ></textarea>
      <mat-error>{{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.MULTI.ERROR' | translate}}</mat-error>
    </mat-form-field>

    <div class="example-container mat-card mat-elevation-z4 p-24">

      <div fxLayout="row" fxLayoutAlign="space-between center" >
        <h3>{{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.MULTI.OPCIONES.TITU' | translate}}</h3>
        <ng-container *ngIf="tipoPregunta == 2 || tipoPregunta ==1 || tipoPregunta==9 ">
        <button mat-mini-fab color="primary" aria-label="agregaOpc" *ngIf="!pasoCompleto"
          matTooltip="{{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.MULTI.TOOLTIP.ADD' | translate}}" (click)="agregaOpcion(tipoPregunta)">
          <mat-icon>add</mat-icon>
        </button>
        </ng-container>
      </div>


      <div cdkDropList (cdkDropListDropped)="drop($event)" fxLayout="column" fxLayoutAlign="space-around stretch">

        <div *ngFor="let opcion of opciones; index as i;"  class="opcionResp" cdkDrag>
          <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
          <div fxLayout="row" fxLayoutAlign="space-between center" >
          <mat-icon *ngIf="!pasoCompleto" aria-hidden="false" class="mr-20" matTooltip="{{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.MULTI.TOOLTIP.MOVE' | translate}}" cdkDragHandle>menu</mat-icon>
          <mat-icon *ngIf="pasoCompleto" aria-hidden="false" class="mr-20">menu</mat-icon>
  <mat-form-field style="width: 400px" appearance="outline" (click)="adverPregunta(i)">
    <mat-label>{{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.MULTI.OPCIONES.INPUT.TITU' | translate}}</mat-label>

    <textarea *ngIf="opcion.datos" matInput required
    [disabled]="!boolTextoPregunta || !boolPregAnterior[i] || pasoCompleto"
    (blur)="guardaOpcion($event, opcion.iterador, i)"
    [(ngModel)]="opcion.datos.respuesta"
    name="textoOpcResp{{i}}"
    ></textarea>

    <textarea *ngIf="!opcion.datos" matInput required
    [disabled]="!boolTextoPregunta || !boolPregAnterior[i] || pasoCompleto"
    (blur)="guardaOpcion($event, opcion.iterador, i)"
    name="textoOpcResp{{i}}"
    ></textarea>

    <mat-error>{{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.MULTI.OPCIONES.INPUT.ERROR' | translate}}</mat-error>
  </mat-form-field>

  <mat-form-field style="width:100px; height:100px; margin-left:10px" appearance="outline" *ngIf="tipoPregunta == 7  || tipoPregunta == 8 || tipoPregunta==9 ">
    <mat-label>{{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.MULTI.MENSAJES.ETIQUET-VALOR'  | translate}}</mat-label>
    <input  *ngIf="opcion.datos" matInput placeholder="Valor"
    [disabled]="!boolTextoPregunta || !boolPregAnterior[i] || pasoCompleto"
    [(ngModel)]="opcion.datos.valor"
    name="valorOpcResp{{i}}"
    (blur)="actualizarValorOpcion($event,opcion.datos._id)">

    <input  *ngIf="!opcion.datos" matInput placeholder="Valor"
    [disabled]="!boolTextoPregunta || !boolPregAnterior[i] || pasoCompleto"
    (blur)="actualizarValorOpcion($event,undefined)">
  </mat-form-field>

  <ng-container *ngIf="tipoPregunta == 2 || tipoPregunta ==1 || tipoPregunta==9">
    <button mat-icon-button aria-label="borraPreg" *ngIf="opciones.length > 2 && !pasoCompleto"
      (click)="borrarOpcion(opcion.iterador)" matTooltip="{{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.MULTI.TOOLTIP.REMOVE' | translate}}" >
      <mat-icon class="s-30 ml-20">delete_forever</mat-icon>
    </button>
  </ng-container>

</div>

        </div>
      </div>

    </div>

  </form>


</div>
